import React from "react";

const Page5Signature = ({
  showAgreement,
  setShowAgreement,
  isMinor,
  signatures,
}) => {
  const signatureSrc = isMinor
    ? signatures?.responsiblePersonSignature
    : signatures?.patientSignature;

  const signatureLabel = isMinor
    ? "Responsible Party Signature"
    : "Patient Signature";

  return (
    <div className="relative">
      {showAgreement ? (
        <div className="w-1/2 rounded-lg bg-white">
          <label className="block text-base font-medium text-black mb-3">
            {signatureLabel}
          </label>

          <img
            src={signatureSrc}
            alt={signatureLabel}
            className="w-[300px] h-[100px] max-w-full rounded-md border border-gray-300 object-contain"
          />
        </div>
      ) : (
        <div className="mb-4">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="radio"
              className="form-radio h-6 w-6 text-indigo-600 border-4 border-gray-400 checked:bg-sky-600 checked:border-sky-700 focus:ring-2 focus:ring-sky-400 transition-all duration-200"
              checked={showAgreement}
              onChange={() => setShowAgreement(true)}
            />
            <span className="ml-3 text-lg font-semibold text-black">
              I Agree <span className="text-red-500">*</span>
            </span>
          </label>
        </div>
      )}
    </div>
  );
};

export default Page5Signature;